/**
 * 获取“当前服务端时间”（毫秒）
 * - 有服务端偏移时：使用本地时间 - 偏移
 * - 无偏移时：退化为本地时间
 */
export const getCurrentServerTimeMs = (user) => {
    const offsetMs = Number(user?.serverTimeOffsetMs);
    if (Number.isFinite(offsetMs)) {
        return Date.now() - offsetMs;
    }
    return Date.now();
};

/**
 * 从用户信息读取今天结束时间（秒）
 */
export const getTodayEndSeconds = (user) => {
    const todayEnd = Number(user?.todayEnd ?? user?.today_end);
    if (Number.isFinite(todayEnd) && todayEnd > 0) {
        return todayEnd;
    }
    return null;
};

/**
 * 计算距离跨天还剩余多少毫秒
 */
export const getRemainingToTodayEndMs = (user) => {
    const todayEndSec = getTodayEndSeconds(user);
    if (todayEndSec === null) {
        return null;
    }

    return Math.max(todayEndSec * 1000 - getCurrentServerTimeMs(user), 0);
};

/**
 * 将剩余毫秒格式化为 HH:mm:ss
 */
export const formatRemainingAsHms = (remainingMs) => {
    const safeMs = Number.isFinite(remainingMs) && remainingMs > 0 ? remainingMs : 0;
    const totalSeconds = Math.floor(safeMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds]
        .map((value) => String(value).padStart(2, '0'))
        .join(':');
};
